<template>
  <div>
    <el-breadcrumb separator="/" style="padding-bottom: 10px;">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      <el-breadcrumb-item>账号列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="table">
      <div class="top">
        <div class="query-container">
          <el-row :gutter="20" class="query-row" label-width="100px">

            <el-col :span="6">
              <el-input  v-model="queryData.keyword" placeholder="请输入搜索内容" />
            </el-col>

            <el-col :span="10" style="float:right">
              <el-button type="primary" @click="onSubmit" size="mini" icon="el-icon-search"> 查询</el-button>
              <el-button type="info" @click="reset" size="mini" icon="el-icon-refresh">重置</el-button>
              <el-button type="success" @click="add" size="mini" icon="el-icon-plus" v-if="userCreateStatus=='true'" >新增</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="content">
        <el-table :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" :data="tableData"
                  border
                  style="width: 100%;" size="mini">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="userName" label="用户账号"></el-table-column>
          <el-table-column prop="nikeName" label="联系人"></el-table-column>
          <el-table-column prop="company" label="影院名称"></el-table-column>
          <el-table-column prop="userType" label="账户角色">
            <template slot-scope="scope">
              <span v-if="scope.row.userType==1">影院</span>
              <span v-if="scope.row.userType==2">IMAX(中国)</span>
              <span v-if="scope.row.userType==3">生产</span>
              <span v-if="scope.row.userType==4">管理员</span>
              <span v-if="scope.row.userType==5">财务</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="修改时间"></el-table-column>
          <el-table-column prop="enable" label="是否启用">
            <template slot-scope="scope">
              <el-switch
                  v-model="scope.row.enable"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="enableUser(($event, scope.row))">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="110px">
            <template slot-scope="scope">

<!--                    <el-button type="text" @click="enableUser(scope.row)" size="small" v-if="userUpdateStatus=='true'">启/禁用</el-button>-->

                    <el-button type="text" @click="dialog(scope.row)" size="small" v-if="userUpdateStatus=='true'">编辑</el-button>

                    <el-button type="text" @click="resetting(scope.row.userId)" size="small" v-if="userResetting=='true'">一键重置密码</el-button>

                    <el-button style="color: #FF0000;" @click="remove(scope.row.userId)" type="text" size="small" v-if="userDeleteStatus=='true'">删除

                    </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom">
        <el-pagination @size-change="handleSizeChange" @current-change="changePage"
                       :current-page="queryData.pageNo"
                       :page-sizes="[15, 25, 40, 50]" :page-size="queryData.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total" style="float: right;">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="新增/编辑"
        :visible.sync="dialogVisible"
        width="50%">
      <span>
        <div ref="pdfContent">
        <el-form ref="formValidate" :model="user"  size="mini" label-width="150px" class="demo-ruleForm" >
         <el-card>
           <div slot="header" class="clearfix">
          <span>用户信息</span>
          </div>
          <el-form-item  prop="userName" style="width: 85%" >
            <template #label>
                <span style="color: red;">*</span> 用户账号
              </template>
            <el-input v-model="user.userInfo.userName" placeholder="请输入用户账号" v-if="user.mode==0" @input="onKeyUp" ></el-input>
            <el-input v-model="user.userInfo.userName" placeholder="请输入用户账号" v-if="user.mode==1" disabled></el-input>
          </el-form-item>
            <el-form-item  prop="nikeName" style="width: 85%" >
              <template #label>
                <span style="color: red;">*</span> 联系人
              </template>
            <el-input v-model="user.userInfo.nikeName" placeholder="请输入联系人"></el-input>
          </el-form-item>
            <el-form-item  prop="phoneNumber" style="width: 85%">
           <template #label>
                <span style="color: red;">*</span> 手机号
              </template>
            <el-input v-model="user.userInfo.phoneNumber" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item  prop="company" style="width: 85%">
            <template #label>
                <span style="color: red;">*</span> 影院名称
              </template>
            <el-input v-model="user.userInfo.company" placeholder="请输入影院名称"></el-input>
          </el-form-item>
           <el-form-item label="用户权限" prop="userType">
             <template #label>
                <span style="color: red;">*</span> 用户权限
              </template>
              <el-radio-group v-model="user.userInfo.userType">
                <el-radio :label="1">影院</el-radio>
                <el-radio :label="2">IMAX(中国)</el-radio>
                 <el-radio :label="3">生产</el-radio>
                <el-radio :label="4">管理员</el-radio>
                <el-radio :label="5">财务</el-radio>
              </el-radio-group>
            </el-form-item>
           </el-card>
          <el-card style="margin-top: 10px">
          <div slot="header" class="clearfix">
          <span>公司信息</span>
          </div>
<!--             <el-form-item label="法人信息" prop="legalPerson" style="width: 85%">-->
<!--            <el-input v-model="user.userInfo.legalPerson" placeholder="请输入法人信息"></el-input>-->
<!--          </el-form-item>-->
            <el-form-item label="营业执照、书屋登记凭证等" >
            <!-- 上传组件 -->
            <el-upload
                ref="upload"
                class="upload-component"
                action="/movie/v1/file/upload"
                :on-success = "handleSuccess"
                :on-remove="handleRemove"
                :show-file-list="false"
                accept="image/*"
            >
<!--                  <i class="el-icon-plus " style="width: 20px;height: 20px"></i>-->
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="图片预览">
            <div v-if="this.userFile.length > 0">
              <ul>
                <li v-for="(image, index) in this.userFile" :key="index" style="display: inline-block; margin: 10px;">
                  <ImageViewer :imageSrc="image.fileUrl" crossorigin="anonymous" alt="Example Image" />
<!--                  <img :src="image.fileUrl" crossorigin="anonymous" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">-->
<!--                  <img :src="image.fileUrl" alt="uploaded image" style="width: 100px; height: 100px; object-fit: cover;">-->
                  <button type="button" @click="removePreview(index)" style="display: block;margin-top: 5px;" class="button-del">删除</button>
                </li>
              </ul>
            </div>
          </el-form-item>
          </el-card>

          <el-card style="margin-top: 10px">
          <div slot="header" class="clearfix">
          <span>银行卡信息</span>
          </div>
          <el-form-item label="银行卡账号" prop="accountNumber" style="width: 85%">
            <el-input v-model="user.bank.accountNumber" placeholder="银行卡账号"></el-input>
          </el-form-item>
          <el-form-item label="银行卡开户行" prop="openingBank" style="width: 85%">
            <el-input v-model="user.bank.openingBank" placeholder="请输入银行卡开户行"></el-input>
          </el-form-item>
          <el-form-item label="持卡人" prop="cardholder" style="width: 85%">
            <el-input v-model="user.bank.cardholder" placeholder="请输入持卡人"></el-input>
          </el-form-item>
          <el-form-item label="卡类型" prop="accountType" style="width: 85%">
<!--            <el-select v-model="user.bank.accountType" filterable placeholder="请选择" style="width: 100% ">-->
<!--              <el-option label="上海银行" value="1"></el-option>-->
<!--              <el-option label="农业银行" value="2"></el-option>-->
<!--              <el-option label="建设银行" value="3"></el-option>-->
<!--            </el-select>-->
            <el-select v-model="user.bank.accountType" placeholder="请选择" size="small">
              <el-option
                  v-for="item in bankTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>


          </el-form-item>
          </el-card>

          <el-card style="margin-top: 10px">
          <div slot="header" class="clearfix">
          <span>发票信息</span>
          </div>
          <el-form-item label="发票抬头" prop="title" style="width: 85%">
            <el-input v-model="user.invoice.title" placeholder="发票抬头"></el-input>
          </el-form-item>
          <el-form-item label="发票类型" prop="invoiceType" style="width: 85%">
            <el-radio-group v-model="user.invoice.invoiceType">
                <el-radio :label="1">企业单位</el-radio>
                <el-radio :label="2">个人/非企业</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="发票纳税号" prop="invoiceNumber" style="width: 85%">
            <el-input v-model="user.invoice.invoiceNumber" placeholder="请输入发票纳税号"></el-input>
          </el-form-item>
            <el-form-item label="发票内容" prop="invoiceContent" style="width: 85%">
            <el-input v-model="user.invoice.invoiceContent" placeholder="请输入发票内容"></el-input>
          </el-form-item>
            <el-form-item label="发票地址" prop="address" style="width: 85%">
            <el-input v-model="user.invoice.address" placeholder="请输入发票地址"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone" style="width: 85%">
            <el-input v-model="user.invoice.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
             <el-form-item label="开户行" prop="openingBank" style="width: 85%">
            <el-input v-model="user.invoice.openingBank" placeholder="请输入开户行"></el-input>
          </el-form-item>
             <el-form-item label="银行账号" prop="accountNumber" style="width: 85%">
            <el-input v-model="user.invoice.accountNumber" placeholder="请输入银行账号"></el-input>
          </el-form-item>

          </el-card>
        </el-form>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">

         <el-button size="small" @click="dialogVisible = false" style="float:left">取 消</el-button>
         <el-form ref="queryData" :model="user" label-width="100px" size="mini">

            <el-button size="small" type="primary" @click="create()" v-if="user.mode==0">保存</el-button>
            <el-button size="small" type="primary" @click="update()" v-if="user.mode==1">修改</el-button>
         </el-form>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import router from "../../router";
import html2pdf from 'html2pdf.js'
import {
  userList,
  createUser,
  updateUser,
  deleteUser,
  resetting,
  getUser,
  enableUser,
  getBankList
} from "../../request/api.js";
// import ImageCarousel from "@/components/ImageCarousel.vue";
import ImageViewer from '@/components/ImageViewer.vue';

export default {
  components: {ImageViewer},
  data() {
    return {
      title: '2025 年度报告',
      dynamicContent: '<p>动态生成的内容...</p>',


      bankTypeOptions: [],

      fileList: [], // 保存上传的文件列表
      imagePreviews: [], // 存储多个图片预览的路径
      uploadResponse: null,

      total: 1,
      id: '',
      userCreateStatus:window.sessionStorage.getItem('userCreateStatus'),
      userListStatus:window.sessionStorage.getItem('userListStatus'),
      userUpdateStatus:window.sessionStorage.getItem('userUpdateStatus'),
      userDeleteStatus:window.sessionStorage.getItem('userDeleteStatus'),
      userResetting:window.sessionStorage.getItem('userResetting'),
      tableData: [],
      queryForm: {
        show: false,
      },
      queryData: {
        keyword: "",
        pageNo: 1,
        size: 15,
      },
      dialogVisible: false,
      user: {
        userInfo:{
          userId: '',
          userName: '',
          nikeName:'',
          company: '',
          phoneNumber:'',
          // legalPerson:'',
          userType1: window.sessionStorage.getItem("userType"),
          userType:  window.sessionStorage.getItem("userType"),
          password:'123456',
          // companyId:'',
        },
        companyParam:{
          userId: '',
          companyId:'',
          list:[
          ],
        },
        bank:{
          userId: '',
          accountNumber:'',
          openingBank:'',
          cardholder:'',
          accountType:'',
        },
        invoice:{
          userId: '',
          title:'',
          invoiceType:'',
          invoiceNumber:'',
          invoiceContent:'',
          address:'',
          phone:'',
          accountNumber:'',
          openingBank:'',
        },
        userId: '',
        mode: 0,
      },
      userFile:[],
    }
  },
  methods: {

    getBankList() {
      getBankList().then((data) => {
        console.log(data.data);
        data.data.forEach(bank => {
          this.bankTypeOptions.push({"value": bank.value, "lable": bank.code})
        })

      })
    },

    onKeyUp() {
      this.user.userInfo.userName = this.user.userInfo.userName.replace(/[\W]/g, '');
    },

    onSubmit() {
      let queryDataForm = "?pageNo="+this.queryData.pageNo
          + "&size="+this.queryData.size
          + "&keyword="+this.queryData.keyword;
      userList(queryDataForm).then((data) => {
        this.tableData = data.data.records;
        this.total = data.data.total;
      })
    },

    reset() {
      this.queryData.orderState = null;
      this.queryData.productName = null;
    },

    add() {
      this.user.userId = 0;
      this.user.userInfo.userId = 0;
      this.user.userInfo.userType = window.sessionStorage.getItem("userType");
      this.user.userInfo.userName = "";
      this.user.userInfo.nikeName = "";
      // this.user.userInfo.password="123456";
      this.user.userInfo.company = "";
      // this.user.userInfo.legalPerson = "";
      this.user.userInfo.companyId = "";
      // this.user.userInfo.userType = "";

      this.user.bank.userId = 0;
      this.user.bank.accountNumber = "";
      this.user.bank.openingBank = "";
      this.user.bank.cardholder = "";
      this.user.bank.accountType = "";

      this.user.companyParam.userId = 0;
      this.user.companyParam.companyId = "";
      this.userFile=[];
      this.user.companyParam.list=[];

      this.user.invoice.userId=0;
      this.user.invoice.title="";
      this.user.invoice.invoiceType="";
      this.user.invoice.invoiceNumber="";
      this.user.invoice.invoiceContent="";
      this.user.invoice.address="";
      this.user.invoice.phone="";
      this.user.invoice.openingBank="";
      this.user.invoice.accountNumber="";

      this.user.mode = 0;
      this.dialogVisible = true;
    },
    userList() {
      let queryDataForm = "?pageNo="+this.queryData.pageNo + "&size="+this.queryData.size + "&keyword="+this.queryData.keyword;
      userList(queryDataForm).then((data) => {
        this.tableData = data.data.records;
        this.total = data.data.total;
      })
    },

    enableUser(row) {
      console.log( "++++++++++++>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> " + row)
      let value = row.enable ? 1 : 0
      enableUser(row.userId, "?enable=" + value).then((data) => {
        console.log(data.data);
        this.$message({
          message: data.msg,
          type: 'success'
        });
      });
    },

    dialog(row) {
      console.log(row)
      this.user.userId = row.userId;
      getUser(row.userId).then((data) =>{
        console.log(data.data);
        this.user.userInfo = data.data.userInfoDTO;
        this.user.bank = data.data.bankDTO
        this.user.invoice = data.data.invoiceDTO;
        this.user.companyParam = data.data.companyDTO;
        this.userFile = data.data.companyDTO.list;
        console.log(this.user)
        if(this.user.companyParam.list=="" || this.user.companyParam.list==null){
          this.userFile = [];
        }
        this.user.mode = 1;
        this.dialogVisible = true;
      })
    },

    exportPDF() {
      const element = this.$refs.pdfContent;

      // 新增：图片加载检测
      const loadImages = () => {
        return Promise.all(
            Array.from(element.querySelectorAll('img'))
                .map(img =>
                    img.complete ? Promise.resolve()
                        : new Promise(resolve => {
                          img.onload = resolve;
                          img.onerror = resolve; // 防止单图失败阻塞流程
                        })
                )
        );
      };

      loadImages().then(() => {
        const opt = {
          html2canvas: {
            useCORS: true,
            scale: 2,
            logging: true // 开启日志调试
          },
          jsPDF: {
            hotfixes: ["px_scaling"],
            format: 'a3'
          }
        };
        html2pdf().set(opt).from(element).save();
      });

    },

    create() {
      // var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      const reg_tel = /^1(3\d|4[5-9]|5[0-3,5-9]|6[2-5]|7[0-8]|8\d|9[1,3,5-9])\d{8}$/;
      if(this.user.userInfo.userName.trim()==""){
        alert('用户账号不能为空');
        return
      }else if(this.user.userInfo.nikeName.trim()==""){
        alert('联系人不能为空');
        return
      }else if(this.user.userInfo.company.trim()==""){
        alert('影院名称不能为空');
        return
      }else if(this.user.userInfo.userType==""){
        alert('用户权限不能为空');
        return
      }else if(!reg_tel.test(this.user.userInfo.phoneNumber)){
        alert('手机号不规范');
        return
      }{
            console.log(this.user);
            createUser(this.user).then((data) => {
              this.dialogVisible = false;
                this.$Message.info(data.msg);
              if (data.data == true) {
                this.userList();
              }
            })
      }
    },
    update() {
      // this.$refs[name].validate((valid) => {
      //   if (valid) {
            var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if(this.user.userInfo.userName.trim()==""){
              alert('用户账号不能为空');
              return
            }else if(this.user.userInfo.nikeName.trim()==""){
              alert('联系人不能为空');
              return
            }else if(this.user.userInfo.company.trim()==""){
              alert('影院名称不能为空');
              return
            }else if(this.user.userInfo.userType==""){
              alert('用户权限不能为空');
              return
            }else if(!reg_tel.test(this.user.userInfo.phoneNumber)){
              alert('手机号不规范');
              return
            }{
            console.log(this.user.userId);
            updateUser(this.user).then((data) => {
              this.dialogVisible = false;
              this.$Message.info(data.msg);
              if (data.data == true) {
                this.userList();
              }
            })
        }
    },
    remove(id) {
      deleteUser(id).then((data) => {
        console.log("删除的结果是:"+data.code)
        if (data.code == 20000) {
          this.$Message.info("删除成功");
          this.userList();
        }
      })
    },
    handleSizeChange(a) {
      this.queryData.size = a;
      this.userList()
    }
    ,
    changePage(page) {
      this.queryData.pageNo = page;
      this.userList()
    }
    ,
    resetting(userId) {
      resetting(userId).then((data) => {
        if (data.code == 20000){
          this.$Message.success("修改成功！你重置的密码是 123456");
        }
      })
    },
    handleSuccess(response) {
      if (response.code === 20000) {
        console.log(response.data)
        // https://jianghexing-oss.oss-cn-beijing.aliyuncs.com/img/图片.jpeg
        this.userFile.push({"fileName":response.data.fileName,"fileUrl":response.data.fileUrl,"fileType":"营业执照"});
        console.log('上传的文件 URL:', response.data.fileUrl);
        this.user.companyParam.list = this.userFile;
       console.log(this.user.companyParam.list)
        // 你可以根据返回的 fileUrl 做其他操作，如展示图片等
      } else {
        console.log('上传失败...:', response);
      }
    },

    // 删除图片预览时的回调
    removePreview(index) {
      // alert(this.userFile);
      // 删除预览图
      this.userFile.splice(index, 1);
      // handleRemove();
      const upload = this.$refs.upload;  // 获取 el-upload 组件的实例
      if (upload && upload.handleRemove) {
        const file = this.fileList[index]; // 获取要删除的文件，这里假设删除第一个文件
        upload.handleRemove(file, this.fileList);  // 手动触发删除操作
      }
    },

    // 删除文件时的回调（ElementUI 自带）
    handleRemove(file, fileList) {
      // 仅同步文件列表
      this.fileList = fileList;
      // 这里确保文件移除时，也移除对应的预览
      this.imagePreviews = this.imagePreviews.filter(preview => preview.url !== URL.createObjectURL(file.raw));
      this.userFile = this.userFile.filter(preview => preview.url !== file.url);
      console.log(">>>>>>>>>> 删除之后",this.userFile)
    },
  },
  created() {
    this.userList();
    this.getBankList();
  }
}
</script>

<style scoped>
.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.table {
  background: #FFF;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: auto;
}

.top {
  margin-bottom: 10px;
}

.top-query {
}

.show-form {
  font-size: 10px;
  margin-left: 8px;
}

.el-icon-arrow-down {
  display: inline-block;
}

.upload-component {
  position: relative;
  margin-bottom: 20px; /* 上传按钮和文件列表之间的间距 */
}

.el-icon-upload {
  position: relative;
}

.image-preview img {
  max-width: 100%;  /* 让图片自适应容器大小 */
  max-height: 300px;  /* 限制图片最大高度 */
  border-radius: 8px;  /* 可选：圆角效果 */
  margin-top: 20px;  /* 图片上方间距 */
}

img {
  border-radius: 8px;
}
.button-del {
  background-color: red;
  color: white;
  border: none;
  right: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.pdfContent img {
  max-width: 100% !important;
  height: auto !important;
  break-inside: avoid;
}
</style>
